// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1GI9A{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}html[dir=ltr] ._1GI9A{border-left:1px solid #e0e8f2;margin-left:1.6rem;padding-left:1.6rem}html[dir=rtl] ._1GI9A{border-right:1px solid #e0e8f2;margin-right:1.6rem;padding-right:1.6rem}._1iYz4{font-weight:700;margin-bottom:.8rem}._1t6f_{color:#6f7ea2}._3fHmU{display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#fff;border-radius:50%;height:48px;height:4.8rem;justify-content:center;overflow:hidden;width:48px;width:4.8rem}html[dir=ltr] ._3fHmU{margin-right:1.6rem}html[dir=rtl] ._3fHmU{margin-left:1.6rem}._3dEp4{color:#fff;display:block;font-size:2.4rem;font-weight:700}._3L3Xn{max-height:100%;width:auto}.eipHz{color:#30a8ff;height:auto;line-height:1.6}.eipHz .btn__labelWrapper{padding:0}._2BbK8{display:inline-block;fill:#30a8ff;height:8px;height:.8rem;margin-right:.5rem;width:8px;width:.8rem}.LsOUt{width:430px;width:43rem}._2UGzd{fill:#6f7ea2;height:20px;height:2rem;width:4px;width:.4rem}", ""]);
// Exports
exports.locals = {
	"clinic": "_1GI9A",
	"clinic__name": "_1iYz4",
	"clinic__address": "_1t6f_",
	"clinic__logo": "_3fHmU",
	"clinic__logo__initials": "_3dEp4",
	"clinic__logo__img": "_3L3Xn",
	"addHcpBtn": "eipHz",
	"addHcpBtn__icon": "_2BbK8",
	"form": "LsOUt",
	"menu__icon": "_2UGzd"
};
module.exports = exports;
